import Grid from '@mui/material/Grid';
import HistoryText from './HistoryText';
import { Pedigree } from '../../../components/Images/Pedigree';


export default function SectionHistory() {

    
    return (

        <Grid container sx={{width: '100vw',  p: {xs:2, md:8, xl:12}, display: 'flex', justifyContent: 'center', alignItems: 'flex-start', bgcolor: 'grey.C050'}}>
  
        <Grid item xs={12} md={3} sx={{p: {xs:2}, mb:{xs:4, } }}> <HistoryText /> </Grid>

        <Grid item xs={12} md={8} sx={{p: {xs:2}, mb:{xs:4, xl:0}, }}> 
             <Pedigree />  
        </Grid>
        
      </Grid>
        
      

    )
}